import * as angular from "angular";
import {IController} from "angular";

export class ProjectStatusCtrl implements IController {
  project: any;
  status: any;

  public colorMap: any;

  /* @ngInject */
  constructor(private planningConstants) {
  }

  $onInit() {
    this.colorMap = this.planningConstants.projectStatusColorMap;
  }
}


angular
  .module('bringoz.admin.planning')
  .component('projectStatus', {
    bindings: {
      project: '<',
      status: '<'
    },
    template: require('./project-status.html').default,
    controller: ProjectStatusCtrl
  });
